<template>
  <el-dialog
    :title="typeof profileRoleTeam.id !== 'undefined' ? 'Edit Profile Role Team' : 'Create Profile Role Team'"
    visible
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="profileRoleTeamForm"
      :rules="rules"
      :model="profileRoleTeam"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Profile"
            prop="profile"
          >
            <el-select
              v-model="profileRoleTeam.profile"
              :loading="isLoadingProfiles"
              value-key="id"
              filterable
              remote
              :remote-method="remoteMethodProfile"
              placeholder="Enter profile name or email"
              class="w-100"
              clearable
            >
              <el-option
                v-for="profile in profiles"
                :key="profile.id"
                :label="formatDisplayProfile(profile)"
                :value="profile"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="Account Role"
            prop="role"
          >
            <el-select
              v-model="profileRoleTeam.role"
              :loading="isLoadingRoles"
              value-key="id"
              placeholder="Select a account role"
              class="w-100"
            >
              <el-option
                v-for="role in roles"
                :key="role.id"
                :label="formatDisplayRole(role)"
                :value="role"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof profileRoleTeam.id !== 'undefined' ? updateProfileRoleTeam() : createProfileRoleTeam()"
      >
        {{ typeof profileRoleTeam.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    profileRoleTeam: {
      type: Object,
      required: true
    },
    accountId: {
      type: String,
      required: true
    },
    teamId: {
      type: String,
      required: true
    },
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      profiles: [],
      isLoadingProfiles: false,
      roles: [],
      isLoadingRoles: false,
      isSaving: false,
      rules: {
        profile: [
          { required: true, message: 'Profile is required', trigger: 'change' }
        ],
        role: [
          { required: true, message: 'Role is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadLists()
    if (this.profileRoleTeam.profile) {
      this.remoteMethodProfile(this.profileRoleTeam.profile.name_full)
    }
  },
  methods: {
    loadLists () {
      // Roles
      this.isLoadingRoles = true
      this.$sdk.role.list(builder => {
        builder.context = { resource: 'account', id: this.$route.params.accountId }
        builder.page = 1
        builder.limit = 1000
        builder.order = 'uuid:asc'
      }).then(res => {
        this.roles = res
      })
        .finally(() => {
          this.isLoadingRoles = false
        })
    },
    remoteMethodProfile (query) {
      this.isLoadingProfiles = true
      this.$sdk.search(query, new this.$sdk.profile())
        .then(res => {
          this.profiles = res
        })
        .finally(() => { this.isLoadingProfiles = false })
    },
    formatDisplayRole (role) {
      if (role) {
        return `${role.name || '-'}, ${role.description || '-'}, ${role.level ? role.level.access : '-'}, ${role.level ? role.level.description : '-'}`
      } else return ''
    },
    formatDisplayProfile (profile) {
      if (profile) {
        return `${profile.name_full || '-'}, ${profile.email || '-'}`
      } else return ''
    },
    createProfileRoleTeam () {
      this.$refs.profileRoleTeamForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          let team = new this.$sdk.team()
          team.id = this.teamId
          this.profileRoleTeam.team = team
          this.profileRoleTeam.create(builder => {
            builder.context = { resource: 'pivot' }
            builder.include = ['profile', 'role', 'team']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updateProfileRoleTeam () {
      this.$refs.profileRoleTeamForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          let team = new this.$sdk.team()
          team.id = this.teamId
          this.profileRoleTeam.team = team
          this.profileRoleTeam.update(builder => {
            builder.context = { resource: 'pivot' }
            builder.include = ['account_team', 'profile', 'account_role']
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
